// apiData.js
import axios from "axios";
import router from "@/router";
import { getToken, removeToken } from "@/utils/auth";
import { ElMessage } from "element-plus";
console.log(process.env.VUE_APP_API_BASE_URL);
// 创建Axios实例
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json;charset=utf-8", // 添加全局请求头
  },
});

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    // 如果是 blob 类型（文件下载），直接返回
    if (response.data instanceof Blob) {
      return response.data;
    }
    if (response.data.code === 200) {
      return response.data;
    } else if (response.data.code === 500) {
      ElMessage({
        message: response.data.msg,
        type: "error",
      });
    } else if (response.data.code === 600) {
      console.log('token过期')
      removeToken();
      router.push("/login");
      ElMessage({
        message: response.data.msg,
        type: "error",
      });
    } else {
      // window.location.replace("/login");
      ElMessage({
        message: response.data.msg,
        type: "error",
      });
      return response.data;
    }
    //
  },
  (error) => {
    console.error("Response error:", error);
    // 统一处理401错误（令牌失效）
    if (error.response && error.response.status === 401) {
      console.error("Token expired or invalid:", error);
    }
    return Promise.reject(error);
  }
);

export default {
  // 图形验证码
  async captchaImage() {
    return apiClient.get(`/api2/captchaImage`);
  },
  // 用户信息
  async getUserInfo() {
    return apiClient.get(`/api2/sysUser/getInfo`);
  },
  // 城市管理接口
  async systemCity() {
    return apiClient.get(`/api2/systemCity/list`);
  },
  // 抖音列表
  async dyAuthList(params) {
    return apiClient.get(`/api2/dyAuth/dyAuthList`, { params });
  },
  async dyDataPage(params) {
    return apiClient.get(`/api2/dyData/dyDataPage`, { params });
  },
  async dyDataCount(params) {
    return apiClient.get(`/api2/dyData/dyDataCount`, { params });
  },
  async dyAuthPage(params) {
    return apiClient.get(`/api2/dyAuth/dyAuthPage`, { params });
  },
  async dyAuth(params) {
    return apiClient.get(`/api2/dyAuth/dyAuth`, { params });
  },

  // 登录
  async sysUserLogin(data) {
    return apiClient.post(`/api2/sysUser/login`, data);
  },
  async updateShutdownTime(params) {
    return apiClient.post(
      `api/pcBase/updateShutdownTime?id=${params.id}&shutdownTime=${params.shutdownTime}`
    );
  },
  async pcBaseList(data) {
    return apiClient.get(`api/pcBase/pcBaseList`, data);
  },
  // 趋势图
  async getpcUserInfo(params) {
    return apiClient.get(`api/pcUseInfo/pcUserInfo`, { params });
  },
  async getpcBaseDetailid(params) {
    return apiClient.get(`api/pcBase/pcBaseDetail`, { params });
  },

  // 登录
  async login(data) {
    return apiClient.post(`/api/jiafang/jiafangLogin`, data);
  },
  // 发布任务分页列表
  async publishTaskPage(params) {
    return apiClient.get(`/api/task/publishTaskPage`, { params });
  },
  // 发布任务下拉列表
  async publishTaskList() {
    return apiClient.get(`/api/task/publishTaskAll`);
  },
  // 发布视频分页列表
  async publishVideoPage(params) {
    return apiClient.get(`/api/task/publishVideoPage`, { params });
  },
  // 查询任务话题
  async queryTitle(params) {
    return apiClient.get(`/api/task/queryTitle`, { params });
  },
  // 修改任务话题
  async updateTitle(data) {
    return apiClient.post(`/api/task/updateTitle`, data);
  },
  // 导出任务链接
  async exportLink(params) {
    return apiClient.get(`/api/task/exportLink`, { params, responseType: "blob" });
  },
  // 发布任务统计数据明细
  async publishTaskStatDetail(params) {
    return apiClient.get(`/api/task/uploadCount`, { params }) ;
  },
};
